import { locale } from './../../ModuleEditor/util/locale-wrapper';

const BREAK_TYPE = {
  PAGE:    'page',
  SECTION: 'section',
};

const BREAK_TYPE_ALL = _.values(BREAK_TYPE);

const BREAK_TYPE_LIST = [
  { label: locale('Page'), description: locale('Creates a page break between fields.'), value: BREAK_TYPE.PAGE },
  {
    label:       locale('Section'),
    description: locale('Displays a horizontal divider between fields.'),
    value:       BREAK_TYPE.SECTION,
  },
];

export { BREAK_TYPE, BREAK_TYPE_LIST, BREAK_TYPE_ALL };

export default BREAK_TYPE;
